import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    staticClass: "scroll-top",
    on: {
      click: _vm.scrollTop
    }
  }, [_c(VIcon, {
    staticClass: "scroll-top-arrow"
  }, [_vm._v("fa-chevron-up")])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };